// generated from 48_366 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const customEventsSinceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("custom_events_since_filter"),
  // undefined: 48_326 (99.92%), defined 40 (0.08%)
  blocklisted: z.literal(true).optional(),
  comparison_key: z.enum([
    "4", // 22_735 (47.01%)
    "6", // 16_116 (33.32%)
    "3", // 5_049 (10.44%)
    "5", // 4_466 (9.23%)
  ]),
  display_name: z.string(),
  // undefined: 48_365 (100.00%), defined 1 (0.00%)
  has_hard_deleted_data: z.literal(true).optional(),
  // undefined: 22_464 (46.45%), defined 25_902 (53.55%)
  raw_value: z
    .union([
      // number samples: 19_198 (74.12%)
      // integer: 14_260 (74.28%)
      // avg: 43.77, min: 0, max: 3640
      z.number().min(0),
      // string samples: 6_704 (25.88%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 38_850 (80.33%)
    // integer: 31_004 (79.80%)
    // avg: 53.12, min: 0, max: 140000
    z.number().min(0),
    // string samples: 9_516 (19.67%)
    // format date: 9_515 (99.99%)
    z.string(),
  ]),
  varies_by_app_group: z.literal(true),
});
